import { createApolloClient as createApolloClientBase } from '@spazious/dollhouse-graphql/apollo';
import typeDefs from '@spazious/dollhouse-graphql/schema.gql?raw';

import { resolvers } from './resolvers/index.js';
import { ApolloContext } from './context.js';

/**
 * Creates an Apollo client with the provided API client.
 */
export const createApolloClient = (context: ApolloContext) => {
  return createApolloClientBase(context, typeDefs, resolvers);
};
